export const standardColours = {
  black: '#000',
  darkerGrey: '#1B1D1D',
  darkGrey: '#242424',
  grey: '#323645',
  lightGrey: '#979797',
  lighterGrey: '#DFDFDF',
  lightestGrey:
    process.env.GATSBY_SITE_THEME !== 'creative' ? '#F5F9FD' : '#FCFBFA', // lightest blueGrey / lightest cream
  white: '#FFF',
  transparentBlack: value => {
    return `rgba(0, 0, 0, ${value})`;
  },
  transparentWhite: value => {
    return `rgba(255, 255, 255, ${value})`;
  },
  transparent: 'rgba(255, 255, 255, 0)',
};

export const elementColours = {
  textColour: standardColours.grey,
};

export const brandColours = {
  primary: process.env.GATSBY_SITE_THEME !== 'creative' ? '#EAF6FF' : '#fef4ea', // lightest blue / lightest orange
  secondary:
    process.env.GATSBY_SITE_THEME !== 'creative' ? '#001E42' : '#192733', // dark blue / dark navy
  tertiary:
    process.env.GATSBY_SITE_THEME !== 'creative' ? '#FFBB36' : '#EC6709', // yellow / orange
  quaternary:
    process.env.GATSBY_SITE_THEME !== 'creative' ? '#0D7FC6' : '#c6630d', // blue / dark orange
  quinary: process.env.GATSBY_SITE_THEME !== 'creative' ? '#6CC7FF' : '#ffac6c', // light blue / light orange
  senary: process.env.GATSBY_SITE_THEME !== 'creative' ? '#798BA6' : '#a68e79', // pastal bluey / brown
  septenary:
    process.env.GATSBY_SITE_THEME !== 'creative' ? '#C1E7FF' : '#ffe1c1', // lighter blue / cream
  octonary:
    process.env.GATSBY_SITE_THEME !== 'creative' ? '#087E8B' : '#324556', // aqua green / navy
  nonary: process.env.GATSBY_SITE_THEME !== 'creative' ? '#88D7A9' : '#d9b084', // pastal green / light brown
  denary: '#066b76', // dark aqua green
  undecenary: '#cfc6e2', // lavender purple
};
